'use client';

import { PropsWithChildren } from 'react';
import { Provider } from 'react-redux';
import RequiredPreloadedState from '@alltrails/core/types/RequiredPreloadedState';
import type Context from '@alltrails/types/Context';
import { buildStore } from '@/utils/redux';

type NotFoundProviderProps = {
  apexDomain: string;
};

export default function NotFoundProvider({ apexDomain, children }: PropsWithChildren<NotFoundProviderProps>) {
  return <Provider store={buildStore({ context: { apexDomain } as Context } as RequiredPreloadedState)}>{children}</Provider>;
}
